import { tns } from 'tiny-slider/src/tiny-slider';

export const shopSliderInit = () => {
  const $shopSlider = document.querySelector('.shop-slider');
  const $numbersBadge = document.querySelector('.shop-slider-outer .slider-numbers');

  function updateDisplayNumber(props) {
    const { slideCount, displayIndex } = props;
    if ($numbersBadge) $numbersBadge.innerHTML = `${displayIndex} / ${slideCount}`;
  }

  if ($shopSlider) {
    const shopSlider = tns({
      container: $shopSlider,
      items: 1,
      slideBy: 1,
      autoplay: false,
      loop: false,
      fixedWidth: false,
      autoplayButton: false,
      nav: false,
      controls: true,
      touch: true,
      controlsText: [ '', '' ],
      gutter: 16,
      onInit: updateDisplayNumber,
      responsive: {
        0: {
          fixedWidth: 288,
          items: 1,
          controls: false,
          gutter: 8
        },
        412: {
          fixedWidth: window.innerWidth - 64,
          items: 1,
          gutter: 16
        },
        768: {
          fixedWidth: 369,
          items: 1
        },
        769: {
          center: false,
          controls: true,
          fixedWidth: false,
          items: 1
        }
      }
    });

    shopSlider.events.on('indexChanged', updateDisplayNumber);
  }
};

export default () => {
  shopSliderInit();
  const $newsSlider = document.querySelector('.news-slider');
  const $contentSlider = document.querySelector('.content-page__slider .slider');
  const $offersSlider = document.querySelector('.offers-slider');

  if ($newsSlider) {
    const newsSlider = tns({
      container: $newsSlider,
      items: 1,
      slideBy: 1,
      autoplay: false,
      fixedWidth: false,
      autoplayButton: false,
      controls: false,
      responsive: {
        0: {
          fixedWidth: 288,
          items: 1
        },
        416: {
          fixedWidth: 369,
          items: 1
        },
        768: {
          fixedWidth: 369,
          items: 1
        },
        769: {
          fixedWidth: false,
          items: 3
        }
      }
    });
  }

  if ($contentSlider) {
    const contentSlider = tns({
      container: $contentSlider,
      items: 1,
      slideBy: 1,
      autoplay: true,
      loop: true,
      controls: true,
      nav: false,
      controlsText: [ '', '' ]
    });
  }

  if ($offersSlider) {
    const offersSlider = tns({
      container: $offersSlider,
      slideBy: 1,
      loop: true,
      controls: true,
      nav: true,
      controlsText: [ '', '' ],
      items: 1,
      responsive: {
        0: {
          items: 1
        },
        640: {
          items: 2,
          gutter: 24
        },
        1024: {
          items: 3,
          gutter: 24
        },
        1280: {
          items: 4,
          gutter: 24
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/sliders.js